import { render, staticRenderFns } from "./budgetsLider.vue?vue&type=template&id=4b5d4668&scoped=true&"
import script from "./budgetsLider.vue?vue&type=script&lang=js&"
export * from "./budgetsLider.vue?vue&type=script&lang=js&"
import style0 from "./budgetsLider.vue?vue&type=style&index=0&id=4b5d4668&prod&scoped=true&lang=css&"
import style1 from "./budgetsLider.vue?vue&type=style&index=1&id=4b5d4668&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5d4668",
  null
  
)

export default component.exports